import VueBaseController from '../../vue_base'

export class IndexController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/ai_content/location_pdfs/index.vue') }
}

export class ShowController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/users/ai_content/location_pdfs/show.vue') }

  static values = {
    id: String
  }
}
